<div class="mat-elevation-z1">
  <table mat-table [dataSource]="dataSource" matSort class="w-100">

    <ng-container matColumnDef="rut">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Rut</th>
      <td mat-cell *matCellDef="let row">{{ formatearRut(row.rut) }} <span *ngIf="row.esExtranjero">(Extranjero)</span></td>
    </ng-container>

    <ng-container matColumnDef="nombreTrabajador">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Trabajador</th>
      <td mat-cell *matCellDef="let row">{{ row.nombreTrabajador || 'Sin vincular' }}</td>
    </ng-container>

    <ng-container matColumnDef="tipoMovimiento">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Movimiento</th>
      <td mat-cell *matCellDef="let row">{{ row.tipoMovimiento }}</td>
    </ng-container>

    <ng-container matColumnDef="estadoLink">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Estado</th>
      <td mat-cell *matCellDef="let row">{{ row.estadoLink }}</td>
    </ng-container>

    <ng-container matColumnDef="fechaGeneracion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Generado</th>
      <td mat-cell *matCellDef="let row">{{ row.fechaGeneracion | date: 'dd-MM-yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="fechaExpiracion">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Vence</th>
      <td mat-cell *matCellDef="let row">{{ row.fechaExpiracion | date: 'dd-MM-yyyy HH:mm' }}</td>
    </ng-container>

    <ng-container matColumnDef="acciones">
      <th mat-header-cell *matHeaderCellDef>Acciones</th>
      <td mat-cell *matCellDef="let row">
        <button mat-icon-button color="primary" matTooltip="Copiar link" (click)="copiarLink(row.token)" [disabled]="row.estadoLink !== 'PENDIENTE'">
          <mat-icon>content_copy</mat-icon>
        </button>
        <button mat-icon-button color="accent" matTooltip="Editar" (click)="abrirEditar(row)">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" matTooltip="Anular" (click)="anular(row)" [disabled]="row.estadoLink === 'ANULADO' || row.estadoLink === 'FIRMADO'">
          <mat-icon>block</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length">No hay links pendientes o vencidos</td>
    </tr>
  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
